import React from "react";

import Text from "src/components/text";
import { SearchTagItem } from "src/types/reports";

import styles from "./searchTagCard.module.scss";

export interface SearchTagCardProps {
  item: SearchTagItem;
}

export const SearchTagCard: React.FC<SearchTagCardProps> = ({ item }) => {
  return (
    <a
      href={`/search/assets?tags=${item.key}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <div className={styles.content}>
          <div className={styles.queryItem}>
            <div className={styles.queryNumber}>{item.manualIndex}</div>
            <div className={styles.data}>
              <Text text={item.key || ""} lines={1} className={styles.title} />
              <div className={styles.metrics}>
                <span>{item.assetCount || 0} Assets</span>
                <span>{item.searchCount || 0} Searches</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};
